export default __webpack_public_path__ + "alberta-pwr.11f68e8a1be87902a325.svg";